export const PASSWORD_REGEX =
  /(?=.*[A-Za-z])(?=.*\d)(?=.*[@\-._!"`'#%&,:;<>=@{}~$()*+/\\?[\]^|])[A-Za-z\d@\-._!"`'#%&,:;<>=@{}~$()*+/\\?[\]^|]{8,100}|(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,100}|(?=.*[A-Za-z])(?=.*[@\-._!"`'#%&,:;<>=@{}~$()*+/\\?[\]^|])[A-Za-z@\-._!"`'#%&,:;<>=@{}~$()*+/\\?[\]^|]|(?=.*\d)(?=.*[@\-._!"`'#%&,:;<>=@{}~$()*+/\\?[\]^|])[\d@\-._!"`'#%&,:;<>=@{}~$()*+/\\?[\]^|]/;
export const NUMBER_REGEX = /[^0-9.]/g;
export const POSITIVE_INTEGER_REGEX = /[^0-9]/g;
export const CAPITALIZE_REGEX = /(^\w{1})|(\s+\w{1})/g;
export const BREAK_LINE_REGEX = /\r?\n/g;
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
